<template>
  <div>
    <!-- 列表对话框 -->
    <el-dialog
      title="住宿信息"
      :visible.sync="listVisible"
      width="800px"
      :close-on-click-modal="false"
    >
      <el-table
        v-loading="listLoading"
        :data="list"
        border
        stripe
        style="width: 100%"
        max-height="500"
        empty-text="暂无数据"
      >
        <el-table-column label="报名信息" width="300" align="left">
          <template slot-scope="scope">
            <div class="cell-content">
              <span class="name-info">
                {{ scope.row.realName
                }}{{
                  scope.row.relationship ? `(${scope.row.relationship})` : ""
                }}{{
                  scope.row.sex === 1 ? "男" : scope.row.sex === 2 ? "女" : ""
                }}
              </span>
              <br />
              {{ maskIdCard(scope.row.idCardNo)
              }}{{ scope.row.isChild ? "(儿童)" : "(成人)" }}
              <br />
              {{ maskMobile(scope.row.mobile) }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="住宿信息" min-width="200" align="left">
          <template slot-scope="scope">
            <div class="cell-content accommodation-info">
              <div v-if="scope.row.rideCarNumber">
                乘坐车辆：{{ scope.row.rideCarNumber }}
              </div>
              <div v-if="scope.row.meetingSeatNumber">
                会议座位号：{{ scope.row.meetingSeatNumber }}
              </div>
              <div v-if="scope.row.stayHotel">
                房间号：{{ scope.row.stayHotel }}
              </div>
              <div v-if="scope.row.diningSeatNumber">
                餐位号：{{ scope.row.diningSeatNumber }}
              </div>
              <div
                v-if="
                  !scope.row.rideCarNumber &&
                    !scope.row.meetingSeatNumber &&
                    !scope.row.stayHotel &&
                    !scope.row.diningSeatNumber
                "
              >
                -
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="150" align="center">
          <template slot-scope="scope">
            <el-button type="text" @click="handleEdit(scope.row)">
              编辑住宿信息
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button @click="listVisible = false">返回</el-button>
      </div>
    </el-dialog>

    <!-- 编辑对话框 -->
    <el-dialog
      title="编辑住宿信息"
      :visible.sync="formVisible"
      width="600px"
      :close-on-click-modal="false"
    >
      <el-form
        ref="dataForm"
        :rules="formRules"
        :model="form"
        label-position="right"
        size="small"
        label-width="100px"
      >
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="房间号">
              <el-input
                v-model="form.stayHotel"
                placeholder="请输入房间号"
                maxlength="20"
                show-word-limit
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="乘坐车辆">
              <el-input
                v-model="form.rideCarNumber"
                placeholder="请输入乘坐车辆"
                maxlength="20"
                show-word-limit
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="会议座位号">
              <el-input
                v-model="form.meetingSeatNumber"
                placeholder="请输入会议座位号"
                maxlength="20"
                show-word-limit
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="餐位号">
              <el-input
                v-model="form.diningSeatNumber"
                placeholder="请输入餐位号"
                maxlength="20"
                show-word-limit
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="formVisible = false">取消</el-button>
        <el-button type="primary" @click="doCreate()">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import meetingSignUpCarryPeopleApi from "@/api/meeting/meetingSignUpCarryPeople";

function initFormBean() {
  const formBean = {
    id: null,
    stayHotel: null,
    rideCarNumber: null,
    meetingSeatNumber: null,
    diningSeatNumber: null
  };
  return formBean;
}

export default {
  data() {
    return {
      listVisible: false,
      listLoading: false,
      list: [],
      currentRow: null,
      old: initFormBean(),
      form: initFormBean(),
      formVisible: false,
      formRules: {},
      signNo: null
    };
  },
  methods: {
    /**
     * 身份证脱敏处理
     */
    maskIdCard(idCard) {
      if (!idCard) return "-";
      if (idCard.length > 8) {
        return (
          idCard.substring(0, 4) +
          "***********" +
          idCard.substring(idCard.length - 4)
        );
      }
      return idCard;
    },
    /**
     * 手机号脱敏处理
     */
    maskMobile(mobile) {
      if (!mobile) return "-";
      if (mobile.length === 11) {
        // 11位手机号：保留前3位和后4位，中间4位用星号代替
        return mobile.substring(0, 3) + "****" + mobile.substring(7);
      } else if (mobile.length > 11) {
        // 如果手机号后面还有其他字符（如"雅"），需要特殊处理
        const phonePart = mobile.substring(0, 11);
        const extraPart = mobile.substring(11);
        return (
          phonePart.substring(0, 3) +
          "****" +
          phonePart.substring(7) +
          extraPart
        );
      }
      // 其他情况直接返回
      return mobile;
    },
    resetForm() {
      for (const key in initFormBean()) {
        this.form[key] = this.old[key];
      }
    },
    /**
     * 打开列表页面
     */
    handleUpdate(row) {
      this.currentRow = row;
      this.signNo = row.signUpNo;
      this.listVisible = true;
      this.loadList();
    },
    /**
     * 加载列表数据
     */
    loadList() {
      if (!this.signNo) {
        this.$message.error("报名号不能为空");
        return;
      }
      this.listLoading = true;
      meetingSignUpCarryPeopleApi
        .fetchListTeev2({
          signNo: this.signNo,
          isGetTransportation: true
        })
        .then(res => {
          if (res && res.data) {
            this.list = res.data || [];
          } else {
            this.list = [];
          }
        })
        .catch(error => {
          this.$message.error(error.msg || "获取列表失败");
          this.list = [];
        })
        .finally(() => {
          this.listLoading = false;
        });
    },
    /**
     * 编辑住宿信息
     */
    handleEdit(row) {
      this.old = { ...row };
      this.resetForm();
      this.form.id = row.id;
      this.formVisible = true;
      this.$nextTick(() => {
        if (this.$refs["dataForm"]) {
          this.$refs["dataForm"].clearValidate();
        }
      });
    },
    /**
     * 执行保存操作
     */
    doCreate() {
      this.$refs["dataForm"].validate(valid => {
        if (valid) {
          meetingSignUpCarryPeopleApi.updatePutStay(this.form).then(data => {
            this.postCallback(data);
          });
        }
      });
    },
    postCallback(response) {
      this.$message.success("操作成功");
      this.formVisible = false;
      // 重新加载列表
      this.loadList();
      this.$emit("created");
    }
  }
};
</script>

<style scoped>
.cell-content {
  word-break: break-word;
  line-height: 1.5;
  color: #6c6c6c;
  font-size: 12px;
}

.name-info {
  color: #000f29;
  font-size: 14px;
}

.accommodation-info {
  color: #6c6c6c;
  font-size: 12px;
}

.dialog-footer {
  text-align: right;
}
</style>
